<template>
<div class="">
    <div class="crumbs">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item><i class="el-icon-lx-copy"></i> {{$t('pages.tabs.breadcrumb')}}</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
    <div class="container">
        <el-tabs v-model="message">
            <el-tab-pane :label="$t('pages.tabs.unreadLabel', { count: unread.length })" name="first">
                <el-table :data="unread" :show-header="false" style="width: 100%">
                    <el-table-column>
                        <template slot-scope="scope">
                            <span class="message-title">{{scope.row.title}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="date" width="180"></el-table-column>
                    <el-table-column width="120">
                        <template slot-scope="scope">
                            <el-button size="small" @click="handleRead(scope.$index, 0)">{{$t('pages.tabs.markRead')}}</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="handle-row">
                    <el-button type="primary" @click="handleRead(0, 1)">{{$t('pages.tabs.markAllRead')}}</el-button>
                </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('pages.tabs.readLabel', { count: read.length })" name="second">
                <template v-if="message === 'second'">
                    <el-table :data="read" :show-header="false" style="width: 100%">
                        <el-table-column>
                            <template slot-scope="scope">
                                <span class="message-title">{{scope.row.title}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="date" width="150"></el-table-column>
                        <el-table-column width="120">
                            <template slot-scope="scope">
                            <el-button type="danger" @click="handleDel(scope.$index, 0)">{{$t('pages.tabs.delete')}}</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="handle-row">
                    <el-button type="danger" @click="handleDel(0, 1)">{{$t('pages.tabs.deleteAll')}}</el-button>
                    </div>
                </template>
            </el-tab-pane>
        </el-tabs>
    </div>
</div>
</template>

<script>
export default {
    name: 'tabs',
    data() {
        return {
            message: 'first',
            showHeader: false,
            unread: [],
            read: [],
            recycle: []
        }
    },
    created() {
        this.getNewMessage();
    },
    methods: {
        getNewMessage() {
            this.$zybhttp
                .get('DataInquiry/GetMessage')
                .then((res) => {
                    if (res.data.status == 0) {
                        var data = res.data.data.list;
                        for (let i = 0; i < data.length; i++) {
                            this.uData = [{
                                index: '',
                                date: '',
                                title: ''
                            }];
                            this.rData = [{
                                index: '',
                                date: '',
                                title: ''
                            }];
                            if (data[i].messageStatus == 0) {
                                this.uData.index = data[i].id;
                                this.uData.date = data[i].messageTime;
                                this.uData.title = data[i].messageContent;
                                this.unread.push(this.uData);
                            } else {
                                this.rData.index = data[i].id;
                                this.rData.date = data[i].messageTime;
                                this.rData.title = data[i].messageContent;
                                this.read.push(this.rData);
                            }
                        }
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.tabs.fetchError')));
        },
        handleRead(index, all) {
            const item = this.unread.splice(index, 1);
            if (item.length == 0) {
                this.$notify.warning(this.$t('pages.tabs.noneWarning'));
                return;
            }
            this.$zybhttp
                .get('DataInquiry/SetReadMessage', {
                    params: {
                        id: item[0].index,
                        allRead: all
                    }
                })
                .then((res) => {
                    if (res.data.status == 0) {
                        if (all == 1) {
                            this.unread = [];
                            this.read = [];
                            this.getNewMessage();
                        } else {
                            this.read = item.concat(this.read);
                        }
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.tabs.listError')));
        },
        handleDel(index, all) {
            const item = this.read.splice(index, 1);
            if (item.length == 0) {
                this.$notify.warning(this.$t('pages.tabs.noneWarning'));
                return;
            }
            this.$zybhttp
                .get('DataInquiry/DelMessage', {
                    params: {
                        id: item[0].index,
                        allDel: all
                    }
                })
                .then((res) => {
                    if (res.data.status == 0) {
                        if (all == 1) {
                            this.read = [];
                        }
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.tabs.listError')));

        },
        handleRestore(index) {
            const item = this.recycle.splice(index, 1);
            this.read = item.concat(this.read);
        }
    },
    computed: {
        unreadNum() {
            return this.unread.length;
        }
    }
}
</script>

<style>
.message-title {
    cursor: pointer;
}

.handle-row {
    margin-top: 30px;
}
</style>
